exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".router-link-exact-active[data-v-3caf675c]{border:1px solid #008fff!important;color:#000!important}@media (max-width:991px){.router-link-exact-active[data-v-3caf675c]{background-color:#e9f2f9!important;color:#000!important;border:none!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3caf675c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Header.vue
// module id = 27
// module chunks = 0